export * from './Icon';
export type { IconName } from './svgs';
